import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AppShell from "@/components/AppShell";
import CheckIn from "@/pages/CheckIn";
import Insights from "@/pages/Insights";
import Companion from "@/pages/Companion";
import Library from "@/pages/Library";
import Settings, { useEveningReminder } from "@/pages/Settings";
import PartnerView from "@/pages/PartnerView";

function Protected({ children }) {
  const { user, ready } = useAuth();
  useEveningReminder();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-[#8C7A70]">one moment…</div>;
  if (!user) return <Navigate to="/signin" replace />;
  return children;
}

function RedirectIfAuthed({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (user) return <Navigate to="/app/checkin" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#FFFDF9",
            color: "#2C221E",
            border: "1px solid #E5D9C8",
            borderRadius: 14,
            fontFamily: "'Plus Jakarta Sans', sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RedirectIfAuthed><Landing /></RedirectIfAuthed>} />
          <Route path="/signin" element={<RedirectIfAuthed><Auth mode="signin" /></RedirectIfAuthed>} />
          <Route path="/signup" element={<RedirectIfAuthed><Auth mode="signup" /></RedirectIfAuthed>} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/share/:token" element={<PartnerView />} />
          <Route path="/app" element={<Protected><AppShell /></Protected>}>
            <Route index element={<Navigate to="checkin" replace />} />
            <Route path="checkin" element={<CheckIn />} />
            <Route path="insights" element={<Insights />} />
            <Route path="companion" element={<Companion />} />
            <Route path="library" element={<Library />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
